import { classicList } from "@/mocks/manhwa";

export default function Classics() {
  return (
    <section id="classic" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-700">
          <i className="ri-vip-crown-2-line"></i> 入坑必读
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black text-foreground-900 md:text-4xl">好看的韩国漫画必看榜</h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          无论你刚入坑还是老读者，这份必看榜都是绕不开的经典。它们以出色的品质与持久的生命力，成为一代代读者的共同记忆。
        </p>
      </div>

      <div className="mt-10 space-y-6">
        {classicList.map((item, idx) => (
          <article
            key={item.title}
            className={`flex flex-col items-center gap-5 rounded-2xl border border-background-200 bg-background-100/60 p-5 md:flex-row md:gap-8 md:p-6 ${
              idx % 2 === 1 ? "md:flex-row-reverse" : ""
            }`}
          >
            <div className="relative shrink-0">
              <img
                src={item.cover}
                alt={`${item.title} 韩国漫画必看榜封面`}
                className="h-52 w-40 rounded-xl object-cover object-top md:h-56 md:w-44"
              />
              <span className="absolute -left-3 -top-3 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 font-heading text-lg font-black text-background-50 shadow-md">
                {idx + 1}
              </span>
            </div>
            <div className="min-w-0 flex-1 text-center md:text-left">
              <div className="flex flex-col items-center gap-1 md:flex-row md:items-center md:justify-between">
                <h3 className="font-heading text-lg font-bold text-foreground-900 md:text-2xl">{item.title}</h3>
                <span className="whitespace-nowrap font-heading text-xl font-black text-primary-600">
                  {item.score.toFixed(1)} 分
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">
                {item.author} · {item.genre}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
              <div className="mt-4 flex flex-wrap items-center justify-center gap-2 md:justify-start">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}